// wallet/slice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getBankLists, getAccountInformation } from "./feature";
import { AccountResolutionResponse, BankResponse, TransactionsResponse, WalletActionType, WalletResponse, WithdrawalAccountResponse } from "./interface";

interface WalletStateProps {
  bankList: BankResponse | null;
  WalletType: WalletActionType;
  accountName: string | null;
  WalletResponse: WalletResponse | null;
  withdrawalAccount:WithdrawalAccountResponse |null
  transactionResponse: TransactionsResponse | null;
  isLoadingBanks: boolean;
  errorBanks: string | null;
  isLoadingAccountName: boolean;
  errorAccountName: string | null;
}

const initialState: WalletStateProps = {
  bankList: null,
  WalletType: "payment",
  accountName: null,
  WalletResponse: null,
  transactionResponse: null,
  isLoadingBanks: false,
  withdrawalAccount:null,
  errorBanks: null,
  isLoadingAccountName: false,
  errorAccountName: null,
};

export const WalletSlice = createSlice({
  name: "wallet",
  initialState,
  reducers: {
    setBankList: (state, action: PayloadAction<BankResponse>) => {
      state.bankList = action.payload;
    },
    setAccountName: (state, action: PayloadAction<string>) => {
      state.accountName = action.payload;
    },
    setWalletType: (state, action: PayloadAction<WalletActionType>) => {
      state.WalletType = action.payload;
    },
    setWalletResponse: (state, action: PayloadAction<WalletResponse>) => {
      state.WalletResponse = action.payload;
    },

    setWithdrawalAccount: (state, action: PayloadAction<WithdrawalAccountResponse>) => {
      state.withdrawalAccount = action.payload;
    },
    setWalletTransactionResponse: (state, action: PayloadAction<TransactionsResponse>) => {
      state.transactionResponse = action.payload;
    },
    setWithdrawalPin:(state, action: PayloadAction<WalletResponse>)=>{
        state.WalletResponse = action.payload;
    }
  },
  extraReducers: (builder) => {
    // getBankLists
    builder
      .addCase(getBankLists.pending, (state) => {
        state.isLoadingBanks = true;
        state.errorBanks = null;
      })
      .addCase(getBankLists.fulfilled, (state, action: PayloadAction<BankResponse>) => {
        state.isLoadingBanks = false;
        state.bankList = action.payload;
      })
      .addCase(getBankLists.rejected, (state, action) => {
        state.isLoadingBanks = false;
        state.errorBanks = action.payload as string;
      });

    // getAccountInformation
    builder
      .addCase(getAccountInformation.pending, (state) => {
        state.isLoadingAccountName = true;
        state.errorAccountName = null;
      })
      .addCase(getAccountInformation.fulfilled, (state, action: PayloadAction<string>) => {
        state.isLoadingAccountName = false;
        state.accountName = action.payload;
      })
      .addCase(getAccountInformation.rejected, (state, action) => {
        state.isLoadingAccountName = false;
        state.errorAccountName = action.payload as string;
      });
  },
});

export const {
  setBankList,
  setWalletType,
  setAccountName,
  setWithdrawalPin,
  setWalletResponse,
  setWithdrawalAccount,
  setWalletTransactionResponse,
} = WalletSlice.actions;

export default WalletSlice.reducer;